module.exports = __webpack_public_path__ + "img/user-guide-02-04-03.4e82770c.png";